import { DataBean } from "../DataBean";

export class QualityGarmentPiece extends DataBean {

  public async getQualityGarmentPieceCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityGarmentPieceCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  // public async getQualityTrainingRender( page: number, rows: number, properties: any ): Promise<any> {
  //   return this.getCustomService(
  //     "ProcessContractERP",
  //     "com.advantage.shared.Report_getQualityTrainingRender_Number_Number_java.util.Map",
  //     [page, rows, properties]
  //   );
  // }

  public async deleteQualityGarmentPiece(idqualitygarmentpiece: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityGarmentPiece_Number", [idqualitygarmentpiece]);
  }

  public async updateQualityGarmentPiece(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityGarmentPiece_updateQualityGarmentPiece_com.orange.finance.processcontract.bean.QualityGarmentPiece",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityGarmentPiece",
        },
      ]
    );
  }
}
